module.exports = __webpack_public_path__ + "static/img/91BM-050-JimYu.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/91BM-050-JimYu.jpg
// module id = 9vnm
// module chunks = 0